// extracted by mini-css-extract-plugin
export var container = "_gn-0";
export var content = "_gn-3";
export var customerTitle = "_gn-4";
export var empty = "_gn-5";
export var gray = "_gn-6";
export var header = "_gn-7";
export var info = "_gn-8";
export var loading = "_gn-2";
export var loadingCard = "_gn-9";
export var oneLine = "_gn-a";
export var personName = "_gn-e";
export var pillContainer = "_gn-b";
export var selected = "_gn-1";
export var text = "_gn-c";
export var twoLines = "_gn-d";
export var unread = "_gn-f";
export var unreadIndicator = "_gn-g";